
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { ClientAvatar } from "./card/ClientAvatar";
import { ClientHeader } from "./card/ClientHeader";
import { ClientContactInfo } from "./card/ClientContactInfo";
import { ClientSubscriptionInfo } from "./card/ClientSubscriptionInfo";
import { ClientActions } from "./card/ClientActions";
import { Client } from "@/types/types";
import { ProfilePhotoCard } from "./tabs/components/details/ProfilePhotoCard";

interface ClientInfoCardProps {
  client: Client;
  onRenewSubscription: () => void;
  onBlockClient: () => void;
  onSendReminder:()=> void;
}

export function ClientInfoCard({ client, onRenewSubscription, onBlockClient, onSendReminder }: ClientInfoCardProps) {
  return (
    <Card className="w-full md:w-1/3">
      <CardHeader className="pb-2">
        <div className="flex justify-between items-start">
        {client.profilePhotoUrl === null ? <ClientAvatar firstName={client.firstName} lastName={client.lastName} />
         : <ProfilePhotoCard profilePhotoUrl={client.profilePhotoUrl}  />}
        </div>
        <ClientHeader client={client} />
      </CardHeader>
      
      <CardContent className="space-y-4">
        <ClientContactInfo client={client} />
        <ClientSubscriptionInfo client={client} />
      </CardContent>
      
      <CardFooter className="flex flex-col space-y-2">
        <ClientActions 
          clientName={`${client.firstName} ${client.lastName}`}
          email={client.email}
          isBlocked={client.status === 'Blocked'}
          onRenewSubscription={onRenewSubscription}
          onBlockClient={onBlockClient}
          onSendReminder={onSendReminder}
        />
      </CardFooter>
    </Card>
  );
}
